export enum ApiEndpoint {
  core,
  crm,
  emissions,
  configuration,
}
